import { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Bookmark } from 'lucide-react';
import axios from 'axios';
import './ContentList.css';
import API_BASE_URL from '../config';

const ContentList = () => {
  const navigate = useNavigate();
  const [contents, setContents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [user, setUser] = useState(null);

  const fetchContents = useCallback(async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/viewer/contents`);
      setContents(response.data);
    } catch (error) {
      setError('컨텐츠 목록을 불러올 수 없습니다.');
      console.error('Contents fetch error:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchContents();

    // 로그인 상태 확인
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, [fetchContents]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  if (loading) {
    return <div className="loading">로딩 중...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="content-list">
      <header className="content-list-header">
        <h1>Shorts로 짧은 영어 극복하기</h1>
        <div className="header-actions">
          {user && (
            <button
              className="bookmarks-nav-button"
              onClick={() => navigate('/bookmarks')}
              title="나의 북마크"
            >
              <Bookmark size={20} />
            </button>
          )}
          {user ? (
            <div className="user-profile">
              <button onClick={handleLogout} className="logout-button mini">로그아웃</button>
            </div>
          ) : (
            <div className="auth-buttons">
              <Link to="/login" className="auth-link">로그인</Link>
              <Link to="/register" className="auth-link register">회원가입</Link>
              <Link to="/admin" className="admin-link">관리자</Link>
            </div>
          )}
        </div>
      </header>

      <div className="notice-banner">
        <div className="notice-content">
          <span className="notice-icon">✨</span>
          <p>회원가입만으로 모두 이용이 가능합니다</p>
        </div>
      </div>

      <div className="contents-grid">
        {contents.length === 0 ? (
          <div className="no-contents">
            <p>등록된 컨텐츠가 없습니다.</p>
          </div>
        ) : (
          contents.map(content => (
            <Link
              key={content.id}
              to={`/viewer/${content.id}/${content.accessKey}`}
              className="content-card"
            >
              <div className="content-thumbnail">
                <img
                  src={`https://img.youtube.com/vi/${content.youtubeId}/maxresdefault.jpg`}
                  alt={content.title}
                  onError={(e) => {
                    e.target.src = `https://img.youtube.com/vi/${content.youtubeId}/hqdefault.jpg`;
                  }}
                />
              </div>
              <div className="content-info">
                <h3>{content.title}</h3>
              </div>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default ContentList;